import { useTranslation }         from 'next-i18next';
import SitePage                   from 'components/Site/Page';
import { initializeStore }        from 'lib/store';
import ArticlesByCategoriesView   from 'views/Articles/ByCategories';
import API                        from 'api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const ArticlesPage = (props) => {
  const { t } = useTranslation('landing');
  const title = t('pages.articles.title');

  return (
    <SitePage
      {...props}
      title={title}
      isLanding={true}
    >
      <ArticlesByCategoriesView
        title={title}
        data={props.data}
      />
    </SitePage>
  )
};

export async function getServerSideProps({ locale, query }) {
  const { category } = query;
  const store = initializeStore();
  const { dispatch } = store;
  const where = {
    b2b: { eq: true },
    articles: {
      id: { neq: null },
      status: { eq: 'PUBLISHED' }
    }
  };

  if (category) {
    where.slug = { eq: category }
  }
  
  const categories = await dispatch(API.queries.articleCategories({
    where, paginate: { limit: 0 }
  }));
  const categoriesData = categories.data.articleCategories.items || [];

  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'header']),
      data: categoriesData
    }
  }
}

export default ArticlesPage;